<mat-form-field>
  <mat-label>{{ "car-workshop-concept.network-type" | translate }}</mat-label
  ><mat-chip-grid #networkList>
    <mat-chip
      class="network"
      *ngFor="let network of selectedNetworksName"
      selectable
      removable
      (removed)="remove(network)"
    >
      {{ network }}
      <mat-icon matChipRemove fontIcon="Bosch-Ic-delete"></mat-icon>
    </mat-chip>
    <input
      #tagInput
      [formControl]="form"
      [matAutocomplete]="auto"
      [matChipInputFor]="networkList"
    />
    <mat-icon
      fontIcon="Bosch-Ic-information"
      matTooltip="{{ 'network-autocomplete-tooltip' | translate }}"
      matTooltipPosition="right"
      matTooltipShowDelay="0"
      matTooltipHideDelay="0"
    ></mat-icon>
  </mat-chip-grid>
  <mat-autocomplete #auto="matAutocomplete">
    <mat-option disabled class="loading" *ngIf="loading">
      <mat-spinner diameter="25"></mat-spinner>
    </mat-option>
    <mat-option
      *ngFor="let filteredNetwork of filteredNetworks"
      [value]="filteredNetwork.name"
      (onSelectionChange)="onSelectionNetwork($event, filteredNetwork.name)"
    >
      {{ filteredNetwork.name }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
